<template>
    <v-navigation-drawer
        v-model="drawer"
        absolute
        temporary
    >
        <v-toolbar color="primary darken-1" dark>
            <img :alt="App.app_name" :src="$t('app.assets.logo')" height="36"/>
            <v-toolbar-title class="ml-0 pl-3">
                <span class="hidden-sm-and-down">{{ App.app_name }}</span>
            </v-toolbar-title>
        </v-toolbar>
        <v-list v-if="drawer" dense>
            <!-- V-For Links From Menu -->
            <!-- Individual Link (Custom Additional) -->
            <v-link
                v-if="$canAccessAnyRoute(['dashboard'])"
                title="Dashboard"
                :href="{ name: 'dashboard' }"
                icon="fa-home"
            />
            <v-list-group v-if="$canAccessAnyRoute(['customers-index', 'vehicles-index', 'products-index', 'employees-index'])" prepend-icon="mdi-account-circle">
                <template v-slot:activator>
                    <v-list-item-content>
                        <v-list-item-title>Fisiere</v-list-item-title>
                    </v-list-item-content>
                </template>
                <v-list-item v-if="$canAccessRoute('customers-index')">
                    <v-link
                        title="Clienti"
                        :href="{ name: 'customers-index' }"
                        icon="supervisor_account"
                    />
                </v-list-item>
                <v-list-item v-if="$canAccessRoute('vehicles-index')">
                    <v-link
                        title="Autoturisme"
                        :href="{ name: 'vehicles-index' }"
                        icon="supervisor_account"
                    />
                </v-list-item>
                <v-list-item v-if="$canAccessRoute('products-index')">
                    <v-link
                        title="Produse"
                        :href="{ name: 'products-index' }"
                        icon="supervisor_account"
                    />
                </v-list-item>
                <v-list-item v-if="$canAccessRoute('employees-index')">
                    <v-link
                        title="Personal"
                        :href="{ name: 'employees-index' }"
                        icon="supervisor_account"
                    />
                </v-list-item>
            </v-list-group>
            <v-list-group v-if="$canAccessAnyRoute(['appointment-index', 'offers-index', 'inspections-index'])" prepend-icon="mdi-account-circle">
                <template v-slot:activator>
                    <v-list-item-content>
                        <v-list-item-title>Operatiuni</v-list-item-title>
                    </v-list-item-content>
                </template>
                <v-list-item v-if="$canAccessRoute('appointment-index')">
                    <v-link
                        title="Programari"
                        :href="{ name: 'appointment-index' }"
                        icon="supervisor_account"
                    />
                </v-list-item>
                <v-list-item v-if="$canAccessRoute('offers-index')">
                    <v-link
                        title="Devize de lucru"
                        :href="{ name: 'offers-index' }"
                        icon="supervisor_account"
                    />
                </v-list-item>
                <v-list-item v-if="$canAccessRoute('inspections-index')">
                    <v-link
                        title="Inspectii tehnice"
                        :href="{ name: 'inspections-index' }"
                        icon="supervisor_account"
                    />
                </v-list-item>
            </v-list-group>

            <v-list-group v-if="$canAccessAnyRoute(['admin-configuration-index', 'admin-users-and-roles-index'])" prepend-icon="mdi-account-circle">
                <template v-slot:activator>
                    <v-list-item-title>Administrare</v-list-item-title>
                </template>
                <v-list-item v-if="$canAccessRoute('admin-configuration-index')">
                    <v-link
                        title="Configuratii"
                        :href="{ name: 'admin-configuration-index' }"
                        icon="supervisor_account"
                    />
                </v-list-item>
                <v-list-item v-if="$canAccessRoute('admin-users-and-roles-index')">
                    <v-link
                        title="Utilizatori"
                        :href="{ name: 'admin-users-and-roles-index' }"
                        icon="supervisor_account"
                    />
                </v-list-item>
            </v-list-group>

            <v-subheader>Utilizator</v-subheader>
            <!--<v-link
                v-if="isAuthenticated"
                title="Contul meu"
                href="/contul-meu"
                icon="fa-cogs"
            />-->
            <v-link
                v-if="isAuthenticated"
                title="Deconectare"
                href="/auth/logout"
                icon="power_settings_new"
            />
            <!-- Guest Links -->
            <v-link
                v-if="!isAuthenticated"
                title="Autentificare"
                href="/auth/login'"
                icon="fa-key"
            />
            <v-link
                v-if="!isAuthenticated"
                title="Inregistrare"
                href="/auth/register"
                icon="fa-user-plus"
            />
        </v-list>
    </v-navigation-drawer>
</template>

<script>
    import VLink from "../components/VLink.vue";
    import ACL from "Mixins/acl";
    import {createNamespacedHelpers} from "vuex";
    const { mapState } = createNamespacedHelpers("auth");

    export default {
        components: {
            VLink
        },
        mixins: [
            ACL
        ],
        data: () => ({
            drawer: false
        }),
        computed: {
            ...mapState({
                isAuthenticated: "isAuthenticated",
            })
        },
        mounted() {
            let self = this;
            Bus.$on("toggleDrawer", function () {
                self.drawer = !self.drawer;
            });
        }
    };
</script>
